export function isPostPurchaseSurveyTeamAllowed(
  teamId?: number | string | null,
  raw: string = import.meta.env.VITE_POST_PURCHASE_SURVEY_TEAM_IDS || '',
): boolean {
  if (!raw.trim())
    return true

  const id = String(teamId ?? '').trim()
  if (!/^[1-9]\d*$/.test(id))
    return false

  return raw.split(',').some(item => item.trim() === id)
}
